import { PreQualificationStatus } from '@ekhodealer/ekho-common';

import { PrequalFailed, PrequalPending, PrequalSucceeded } from '@common/components/icons';

interface PrequalIconProps {
	status: PreQualificationStatus | undefined;
}

export const PrequalIcon = ({ status }: PrequalIconProps) => {
	switch (status) {
		case PreQualificationStatus.REJECTED:
			return <PrequalFailed />;
		case PreQualificationStatus.PRE_QUALIFIED:
			return <PrequalSucceeded />;
		default:
			return <PrequalPending />;
	}
};
